//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import addressPopup from '../address/addressPopup.vue'
import compressImage from '../common/compressImage'
export default {
    components: {
        addressPopup
    },
    mixins: [compressImage],
    data() {
        return {
            inputReset: true,
            sexAction: false,
            sexList: [{
                label: '男',
                value: 1
            }, {
                label: '女',
                value: 2
            }],
            userInfo: {
                sex: '请选择',
                birthday: '请选择',
                name: "请填写",
                phone: "请填写",
                addressStr: '请选择',
                addressList: [],
                poster: './static/images/default_handsome.jpg'
            }
        }
    },
    methods: {
        sureSex(menuKey, menuItem) {
            if(menuItem) {
                let that = this;
                var data  = {
                    shopperId: that.userInfo.shopperId,
                    gender: menuItem.value
                }
                that.ajaxSetUserInfo('/api/v1.0/lonbonShop/changeGender', data, () => {
                    that.userInfo.sex = menuItem.label;
                })
            }
        },
        //设置生日
        showPlugin () {
            let that = this;
            var startDate = this.$moment().subtract(100,'years').format("YYYY-MM-DD");
            var endDate = this.$moment().format("YYYY-MM-DD");
            var value = '';
            if(!that.userInfo.birthday || that.userInfo.birthday=='请选择') {
                value = '1994-9-24';
            } else {
                value = that.userInfo.birthday;
            }
            this.$vux.datetime.show({
                cancelText: '取消',
                confirmText: '确定',
                format: 'YYYY-MM-DD',
                startDate: startDate,
                endDate: endDate,
                value: value,
                onConfirm (val) {
                    var ss = (val + ' 00:00:00').replace(/-/g,'/');
                    var data  = {
                        shopperId: that.userInfo.shopperId,
                        birthday: ((new Date(ss)).getTime()) / 1000
                    }
                    that.ajaxSetUserInfo('/api/v1.0/lonbonShop/changeBirthday', data, () => {
                        that.userInfo.birthday = val;
                    })
                }
            })
        },
        showSetInfo(title, key) {
            let that = this;
            that.$vux.confirm.prompt(that.userInfo[key],{
                title: '请填写' + title,
                closeOnConfirm: false,
                onConfirm (value) {
                    if(!value) {
                        that.$vux.toast.text('请填写');
                    } else {
                        var url = '', data = {};
                        if(key == 'phone') {
                            url = '/api/v1.0/lonbonShop/changePhoneNum';
                            data ={
                                shopperId: that.userInfo.shopperId,
                                phoneNum: value
                            }
                        }
                        if(key == 'name') {
                            url = '/api/v1.0/lonbonShop/changeDisplayName';
                            data ={
                                shopperId: that.userInfo.shopperId,
                                displayName: value
                            }
                            that.$store.state.userInfo.displayName = value;
                        }
                        that.ajaxSetUserInfo(url, data, () => {
                            that.userInfo[key] = value;
                        })
                        that.$vux.confirm.hide();
                    }
                    
                },
                onShow() {
                    $("input").blur(function() {
                        that.$store.state.APPPAGE.blurFun();
                    })
                }
            })
        },
        //地区选择
        showSetAddress() {
            this.$refs.addressPopupRef.showPopup(this.userInfo.addressList);
        },
        selectAddressHandle(list) {
            this.userInfo.addressList = list;
            var regionCombinationArr = [], regionDescArr = [];
            list.forEach((item) => {
                regionCombinationArr.push(item.regionId);
                regionDescArr.push(item.regionName);
            })
            let that = this;
            var data = {
                shopperId: that.userInfo.shopperId,
                regionCombination: regionCombinationArr.join("|"),
                regionDesc: regionDescArr.join("/")
            }
            that.ajaxSetUserInfo('/api/v1.0/lonbonShop/changeRegion', data, () => {
                that.userInfo.addressStr = regionDescArr.join("/");
            })
        },
        //头像选择
        upload () {
            console.log("头像选择");
            this.$refs.uploadImagesRef.dispatchEvent(new MouseEvent('click'));
        },
        changeImage(e) {
            let that = this;
            that.$vux.loading.show();
            var files = e.target.files;
            var file = files[0];
            that.myCompressImage(file, function(result) {
                that.userInfo.poster = that.$store.state.userInfo.poster = result;
                var formData = new FormData();
                formData.append("shopperId", that.userInfo.shopperId);
                formData.append("file", that.convertBase64UrlToBlob(that.uploadImage), file.name);
                that.$axios.post('/api/v1.0/lonbonShop/changeHeadImage', formData).then(function (response) {
                    if(response.status == 200) {
                        that.$vux.toast.text('已保存');
                        that.$vux.loading.hide();
                    }
                })
            })
            this.inputReset = false;
            this.$nextTick(() => {
                this.inputReset = true;
            })
        },
        //获取用户信息
        getUserInfo() {
            let that = this;
            let accountType;
            if (that.$isWeixin() || that.$isPc()) {
                accountType = 10;
            } else {
                accountType = 1;
            }
            that.$axios.get('/api/v1.0/lonbonShop/userInfo', {
                params: {
                    accountType: accountType
                }
            }).then(function (response) {
                if(response.status == 200) {
                    var user = response.body;
                    var genderStr = '请选择';
                    if(user.gender) {
                        if(user.gender == 1) {
                            genderStr = '男';
                        } else {
                            genderStr = '女';
                        }
                    }
                    var addressList = [];
                    if(user.regionCombination && user.regionDesc) {
                        var regionCombinationArr = user.regionCombination.split("|"), regionDescArr = user.regionDesc.split("/");
                        regionCombinationArr.forEach((item, index) => {
                            addressList.push({
                                regionId: regionCombinationArr[index],
                                regionName: regionDescArr[index]
                            })
                        })
                    }
                    var userInfo = {
                        poster: that.$store.state.APPPAGE.dealHeadImage(user.headImage),
                        name: user.displayName ? user.displayName : '请填写',
                        accountId: user.accountId,
                        shopperId: user.shopperId,
                        sex: genderStr,
                        birthday: user.birthday ? that.$moment(user.birthday*1000).format("YYYY-MM-DD") : '请选择',
                        phone: user.phoneNum ? user.phoneNum : "请填写",
                        addressStr: user.regionDesc ? user.regionDesc : '请选择',
                        addressList: addressList,
                    }
                    //微信小程序授权获得的信息
                    if(sessionStorage.weixinAppInfo) {
                        var weixinAppInfo = JSON.parse(sessionStorage.weixinAppInfo);
                        userInfo.poster = userInfo.poster != that.$store.state.APPPAGE.defaultPoster ? userInfo.poster : weixinAppInfo.avatarUrl;
                        userInfo.name = userInfo.name ? userInfo.name : weixinAppInfo.nickName;
                    }
                    that.userInfo = userInfo;
                }
            })
        },
        ajaxSetUserInfo(url, data, callback) {
            let that = this;
            that.$axios.post(url, that.qs.stringify(data)).then(function (response) {
                if(response.status == 200) {
                    that.$vux.toast.text('已保存');
                    callback&&callback();
                }
            })
        }
    },
    mounted() {
        this.getUserInfo();
    }
}



// WEBPACK FOOTER //
// ./src/components/mine/info.vue